import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "新作" },
  { value: 2, text: "再販" },
]);
